'use strict';

const _ = require('underscore');
const Victor = require('victor');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Snackbar = require('common/util/snackbar');
const RootView = require('common/ui/view/svg/root');
const FrameView = require('common/ui/view/svg/frame');
const GridView = require('common/ui/view/svg/grid');
const VectorUtil = require('common/vector-util');
const CollectionView = require('common/ui/view/svg/collection');
const Route = require('common/route');
const ElementAction = require('system/domain/action/element');
const ElementRepository = require('system/domain/repository/element');
const DiagramRepository = require('system/domain/repository/diagram');
const CanvasMenu = require('system/ui/view/menu/canvas');
const MultiEditMenu = require('system/ui/view/menu/multi-edit');
const RectSelectorView = require('system/ui/view/rect-selector');
const Shortcuts = require('system/ui/view/shortcuts');
const RecordView = require('system/ui/view/element/record');
const RelationView = require('system/ui/view/element/relation');

const params = {
    scale: {
        init: 0.3,
        min: 0.01,  // zoom out limit
        max: 0.6  // zoom in limit
    },
    width: 102400,
    height: 102400
};

const globalHeaderHeight = 44;
const coverHeight = 44 + 36;
const toolbarHeight = 44;

module.exports = Mn.View.extend({
    template: false,
    widthFactor: 1,

    onDestroy: function() {
        if (this.shortcuts) {
            this.shortcuts.destroy();
        }
    },

    onRender: function() {
        const diagram = this.model;
        const group = this.getOption('group');
        const members = group.getMembers();
        const user = this.getOption('user');
        const context = this.getOption('context');
        const oldContext = this.getOption('oldContext');
        const auth = this.getOption('auth');
        const channel = this.getOption('channel');
        channel.reply('change:mode', mode => {
            auth.set({mode: mode});
        });
        auth.on('change:mode', auth => {
            channel.trigger('change:mode', auth.get('mode'));
        });

        this.shortcuts = new Shortcuts({
            context: oldContext,
            channel: channel,
            auth: auth
        });
        this.shortcuts.setDiagram(diagram);

        const headerHeight = globalHeaderHeight + coverHeight + toolbarHeight;
        const root = new RootView({
            centerOrigin: true,
            viewPort: {
                width: $(window).width() * this.getOption('widthFactor'),
                height: $(window).height() - headerHeight
            }
        });
        this.$el.append(root.render().el);
        $(window).resize(() => {
            root.resize({
                width: $(window).width() * this.getOption('widthFactor'),
                height: $(window).height() - headerHeight
            });
        });
        this._root = root;

        const frame = new FrameView({
            size: {
                width: params.width,
                height: params.height
            },
            init: {
                scale: params.scale.init
            },
            scale: params.scale,
            includeDefs: true
        });
        root.$el.append(frame.render().el);
        frame.zoomTo({
            x: 0, y: 0, scale: params.scale.init, duration: 0
        });
        this.frame = frame;

        this.initializeMenu(root, diagram, auth, frame, channel, oldContext);
        this.selector(channel, auth, oldContext);
        this.linker(oldContext, channel, auth);
        this.bend(diagram, oldContext);

        const grid = new GridView({
            width: params.width,
            height: params.height,
            includeDefs: true
        });
        frame.$el.append(grid.render().el);
        grid.show();

        const RecordsView = CollectionView.extend({
            className: 'records',
            childView: RecordView,
            initialize: function() {
                RecordsView.__super__.initialize.call(this);
                const nodeMetas = DiagramRepository.getNodeMetas({
                    context: oldContext
                });
                this.listenTo(nodeMetas, 'change:is_zone', this.render);
                this.listenTo(nodeMetas, 'add', this.render);
            },
            buildChildView: function(d) {
                return new this.childView({
                    model: d,
                    meta: diagram.getNodeMeta(d.id),
                    diagram: diagram,
                    members: members,
                    context: oldContext,
                    auth: auth,
                    channel: channel
                });
            },
            filter: function(child) {
                const meta = diagram.getNodeMeta(child.id);
                return !child.get('deleted') && meta &&
                    !meta.get('is_zone');
            }
        });
        const recordsView = new RecordsView({
            collection: ElementRepository.getNodes({
                context: oldContext
            })
        });

        const ZonesView = RecordsView.extend({
            className: 'zone',
            filter: function(child) {
                const meta = diagram.getNodeMeta(child.id);
                return !child.get('deleted') && meta &&
                    meta.get('is_zone');
            }
        });
        const zonesView = new ZonesView({
            collection: ElementRepository.getNodes({
                context: oldContext
            })
        });

        const RelationsView = CollectionView.extend({
            className: 'relations',
            childView: RelationView,
            initialize: function() {
                RelationsView.__super__.initialize.call(this);
                this.listenTo(DiagramRepository.getNodeMetas({
                    context: oldContext
                }), 'change:is_zone', this.render);
                this.listenTo(DiagramRepository.getLinkMetas({
                    context: oldContext
                }), 'add', this.render);
                this.listenTo(ElementRepository.getLinks({
                    context: oldContext
                }), 'change:source change:target', this.render);
                this.listenTo(ElementRepository.getLinks({
                    context: oldContext
                }), 'select deselect', _.bind(function(){
                    if(auth.isMultiSelectable()){
                        return;
                    }
                    this.render();
                }, this));
            },
            buildChildView: function(d) {
                return new this.childView({
                    model: d,
                    meta: diagram.getLinkMeta(d.id),
                    context: oldContext,
                    auth: auth,
                    channel: channel,
                    findNodeView: function(model) {
                        const view = recordsView.children.findByModel(model);
                        if(!view) {
                            return zonesView.children.findByModel(model);
                        }
                        return view;
                    }
                });
            },
            filter: function(child) {
                return !child.get('deleted') &&
                    diagram.getLinkMeta(child.id) &&
                    !child.selected;
            }
        });
        const relationsView = new RelationsView({
            collection: ElementRepository.getLinks({
                context: oldContext
            })
        });
        const SelectedRelationsView = RelationsView.extend({
            initialize: function() {
                RelationsView.__super__.initialize.call(this);
                this.listenTo(ElementRepository.getLinks({
                    context: oldContext
                }), 'change:source change:target', this.render);
                this.listenTo(ElementRepository.getLinks({
                    context: oldContext
                }), 'select deselect', _.bind(function(){
                    if(auth.isMultiSelectable()){
                        return;
                    }
                    this.render();
                }, this));
            },
            filter: function(child) {
                return !child.get('deleted') &&
                    diagram.getLinkMeta(child.id) &&
                    child.selected;
            }
        });
        const selectedRelationsView = new SelectedRelationsView({
            collection: ElementRepository.getLinks({
                context: oldContext
            })
        });

        // それぞれの View を適切な順番で render
        recordsView.render();
        frame.$el.append(zonesView.render().el);
        frame.$el.append(relationsView.render().el);
        frame.$el.append(recordsView.render().el);
        frame.$el.append(selectedRelationsView.render().el);
        frame.$el.append('g').classed('menus', true);

    },

    initializeMenu: function(root, diagram, auth, frame, channel, oldContext) {
        const contentMenu = new CanvasMenu({
            diagram: diagram,
            canvas: frame,
            context: oldContext,
            channel: channel,
            auth: auth,
            group: this.getOption('group'),
            user: this.getOption('user')
        });

        const defaultMode = auth.getMode();
        frame.on('click', (pos, scale) => {
            if(auth.getMode() == 'multi' || auth.getMode() == 'rectSelect') {
                channel.request('change:mode', defaultMode);
            } else if(auth.getMode() == 'edit') {
                channel.trigger('cmd:selector:clear');
            }
        });
        frame.on('dblclick', function(pos, scale) {
            if (auth.isCreatable()) {
                contentMenu.addNode(pos, scale);

                // キャンバスの左端の方にノードを作ると、詳細ペインで隠れてしまうため
                // 少し全体をずらして、チラ見させる
                const center = frame.center();
                // x は画面のスケールに変換した、キャンパス中心からの x 方向の座標
                const x = (pos.x - center.x) * frame.scale();
                // hideX はこの値より x が小さいと詳細ペインに隠れるというスレッショルド
                // 384 は詳細ペインの幅、キャンバスの横幅は window.width に等しい
                const hideX = - $(window).width() / 2 + 384;

                if(x < hideX) {
                    frame.zoomTo({
                        x: center.x - (hideX - x) / scale,
                        y: center.y
                    }, scale);
                }
            }
        });
        let multiEditMenu = null;
        let currentMode = auth.get('mode');
        channel.on('change:mode', mode => {
            const viewPort = this._root.getViewPort();
            const detailViewWidth = 384;

            if(currentMode == mode) {
                return;
            }
            currentMode = mode;

            if(mode == 'multi') {
                const multiEditR = 100;
                multiEditMenu = new MultiEditMenu({
                    r: multiEditR,
                    channel: channel,
                    context: oldContext,
                    group: this.getOption('group'),
                    project: this.getOption('project')
                });
                multiEditMenu.render(
                    root.$el,
                    {
                        x: - viewPort.width / 2 + detailViewWidth + multiEditR * 1.5,
                        y: - viewPort.height / 2 + 24
                    },
                    1.0,
                    {
                        startAngle: 190,
                        endAngle: 330,
                        circle: false
                    }
                );
            } else {
                if(multiEditMenu) {
                    multiEditMenu.remove();
                    multiEditMenu = null;
                }
            }
        });

        let rectSelector = null;
        channel.on('keypress:shift', function() {
            frame.disableZoom();
        });
        channel.on('keyup:shift', function() {
            frame.enableZoom();
            if(rectSelector) {
                rectSelector.remove();
                rectSelector = null;
            }
        });
        frame.on('dragstart', function(pos) {
            if(!rectSelector) {
                rectSelector = new RectSelectorView({start: pos});
                frame.$el.append(rectSelector.render().el);
            }
        });
        frame.on('drag', function(pos) {
            if(!rectSelector) {
                return;
            }
            rectSelector.update(pos);
        });
        frame.on('dragend', function() {
            if(!rectSelector) {
                return;
            }
            channel.request('canvas:selectWithin',
                rectSelector.topLeft(), rectSelector.bottomRight());
            rectSelector.remove();
            rectSelector = null;
        });

        channel.reply('canvas:addLink', function(source, target, pos){
            contentMenu.addLink(source, target, pos);
        });
        frame.on('click', function(pos, scale) {
            channel.trigger('canvas:click', pos, scale);
        });

        channel.reply('canvas:zoomTo', function(model, duration){
            let pos = {};
            if(model.kind == 'node') {
                let meta = diagram.getNodeMeta(model);
                pos = {
                    x: meta.x,
                    y: meta.y
                };
            } else if(model.kind == 'link') {
                // link の場合は中間点
                const source = diagram.getNodeMeta(model.source);
                const target = diagram.getNodeMeta(model.target);
                pos = VectorUtil.interpolate(source, target, 0.5);
            } else {
                pos = model;
            }
            pos.duration = duration;
            frame.zoomTo(pos);
        });
        channel.reply('canvas:scale', function(){
            return frame.scale();
        });
        channel.reply('canvas:center', function(){
            return frame.center();
        });
        channel.reply('canvas:showFull', function(duration){
            const rect = diagram.calcRectContainNodes(ElementRepository.getNodes({
                context: oldContext
            }).models);

            if(rect == null) {
                return;
            }

            const initScale = 0.3;
            let scale = Math.min(
                $(window).width() / rect.width,
                $(window).height() / rect.height);
            scale = scale < initScale ? scale : initScale;
            scale *= 0.8;

            frame.zoomTo({
                x: rect.center.x,
                y: rect.center.y,
                scale: scale,
                duration: duration
            });
        });
        channel.reply('canvas:changeNodeType', function(node){
            contentMenu.changeNodeType(node);
        });
        channel.reply('canvas:editNodeMenu', function(node){
            contentMenu.renderNodeEditMenuEntry(node, frame.scale());
        });
        channel.reply('canvas:changeLinkType', function(link){
            contentMenu.changeLinkType(null, null, link);
        });
        channel.reply('toolbar:addNode', function(){
            if(auth.isLocked()) {
                auth.unlock();
                Snackbar.info(i18n.t('balus_template_body_diagram:snackbar.lock-off'));
            }

            if (auth.isCreatable()) {
                let pos = frame.centerVector();
                const randomize = new Victor(
                    (Math.floor(Math.random() * 11) - 5) * 32,
                    (Math.floor(Math.random() * 11) - 5) * 32
                );
                pos.add(randomize);
                contentMenu.addNode(pos, frame.scale());
            }
        });
        channel.reply('canvas:addLink', function(source, target, pos){
            contentMenu.addLink(source, target, pos);
        });
        channel.reply('canvas:selectWithin', function(start, end){
            const x = {
                min: Math.min(start.x, end.x),
                max: Math.max(start.x, end.x)
            };
            const y = {
                min: Math.min(start.y, end.y),
                max: Math.max(start.y, end.y)
            };

            const nodes = ElementRepository.getNodes({
                context: oldContext
            });
            nodes.each(function(node){
                const meta = diagram.getNodeMeta(node.id);
                if(!meta) {
                    return;
                }
                if(x.min <= meta.x && meta.x <= x.max &&
                    y.min <= meta.y && meta.y <= y.max) {
                    node.select();
                }
            });

            const links = ElementRepository.getLinks({
                context: oldContext
            });
            links.each(function(link){
                const meta = diagram.getLinkMeta(link.id);
                if(!meta) {
                    return;
                }
                const s = diagram.getNodeMeta(link.source.id);
                const t = diagram.getNodeMeta(link.target.id);
                const lx = (s.x + t.x) / 2;
                const ly = (s.y + t.y) / 2;
                if(x.min <= lx && lx <= x.max &&
                    y.min <= ly && ly <= y.max) {
                    link.select();
                }
            });
        });
    },

    selector: function(channel, auth, oldContext) {
        const nodes = ElementRepository.getNodes({context: oldContext});
        const links = ElementRepository.getLinks({context: oldContext});

        const getSelected = function(collection) {
            return collection.filter(function(model) {
                return model.selected;
            });
        };
        const clearSelectExcept = function(model) {
            _.each(_.union(getSelected(nodes), getSelected(links)),
                function(m){
                    if (model && model.id == m.id) {
                        return;
                    }
                    m.deselect();
                });
        };
        const select = function(model) {
            if(auth.isMultiSelectable()) {
                return;
            }
            clearSelectExcept(model);
            if(model.editing && model.kind == 'node') {
                channel.request('canvas:editNodeMenu', model);
            }
        };
        const setHash = function(model) {
            if(auth.isMultiSelectable()) {
                if(location.hash != '#') {
                    location.hash = '#';
                }
                return;
            }

            location.replace(Route.urlFor('diagram:element', {id: model.id}));
        };

        this.listenTo(nodes, 'before:select', select);
        this.listenTo(links, 'before:select', select);
        this.listenTo(nodes, 'select', setHash);
        this.listenTo(links, 'select', setHash);
        this.listenTo(nodes, 'dblclick', model => {
            if(!auth.isEditable()) {
                return;
            }

            this.listenTo(this.model, 'dblclick',
                ElementAction.startEditNode({
                    context: oldContext,
                    node: {id: model.id}
                }));
            channel.request('canvas:editNodeMenu', model);
        });
        this.listenTo(auth, 'change', select);
        this.listenTo(channel, 'cmd:selector:clear', clearSelectExcept);
        channel.reply('req:nodes:selected', function() {
            return getSelected(nodes);
        });
        channel.reply('req:links:selected', function() {
            return getSelected(links);
        });

        /**
         * 複数選択関連
         */
        const diagram = this.model;
        const getSelectedNodes = function() {
            return ElementRepository.getNodes({
                context: oldContext
            }).filter(function(model) {
                return model.selected;
            });
        };
        const move = function(dpos) {
            _.each(getSelectedNodes(), function(m){
                const meta = diagram.getNodeMeta(m.id);
                meta.move(dpos);
            });
        };
        const moveEnd = function() {
            _.each(getSelectedNodes(), function(m) {
                const meta = diagram.getNodeMeta(m.id);
                meta.moveend();
            });
        };

        this.listenTo(auth, 'change', function() {
            ElementRepository.getNodes({
                context: oldContext
            })
                .each(function(node) {
                    const meta = diagram.getNodeMeta(node.id);
                    if(!meta) {
                        return;
                    }
                    if(auth.isMultiSelectable()) {
                        meta.custom_move = move;
                        meta.custom_moveend = moveEnd;
                    } else {
                        meta.custom_move = null;
                        meta.custom_moveend = null;
                    }
                });
        });
    },

    linker: function(oldContext, channel, auth) {
        const nodeMetas = DiagramRepository.getNodeMetas({context: oldContext});
        const nodes = ElementRepository.getNodes({context: oldContext});
        let sourceNode = null;

        const onNodeSelect = function(model) {
            if(!auth.isLinkCreatable()) {
                return;
            }
            const meta = nodeMetas.get(model.id);
            sourceNode = model;
            setTimeout(function() {
                channel.trigger('linker:render', model, meta);
            }, 1);
        };

        const onMoveEnd = function(pos, meta) {
            if(!auth.isLinkCreatable()) {
                return;
            }
            if(!sourceNode || !sourceNode.selected) {
                return;
            }
            meta = nodeMetas.get(sourceNode.id);
            setTimeout(function() {
                channel.trigger('linker:render', sourceNode, meta);
            }, 1);
        };

        const removeLinker = function() {
            channel.trigger('linker:remove');
        };

        this.listenTo(nodes, 'select', onNodeSelect);
        this.listenTo(nodeMetas, 'moveEnd', onMoveEnd);
        this.listenTo(nodes, 'deselect', removeLinker);
        this.listenTo(auth, 'deselect', removeLinker);
    },

    bend: function(diagram, oldContext) {
        // Relation が追加された時に、いい感じに bend させるためのロジック
        const links = ElementRepository.getLinks({context: oldContext});

        const bend = function(r) {
            if (!r.get('creating')) {
                return;
            }

            const targetLinks =links.getLinksHasEdgeOf(r.source.id, r.target.id);

            const dList = _.chain(targetLinks)
                .filter(function (link) {
                    return link.id != r.id &&
                        diagram.hasLink(link);
                })
                .map(function (link) {
                    const meta = diagram.getLinkMeta(link.id);
                    const bendAt = meta.get('vendAt');
                    if (!bendAt) {
                        return 0;
                    } else {
                        if (link.source.id == r.source.id) {
                            return bendAt.d;
                        } else {
                            return -bendAt.d;
                        }
                    }
                })
                .value();

            if (dList.length == 0) {
                return;
            }

            const interval = 64;
            let d = interval;
            while (true) {
                const ks = _.filter(dList, function (_d) {
                    return d - interval / 2 <= _d &&
                        _d <= d + interval / 2;
                });
                if (ks.length == 0) {
                    break;
                }

                if (d < 0) {
                    d = -d + interval;
                } else {
                    d = -d;
                }
            }

            const bendAt = {
                r: 0.5,
                d: d
            };
            setTimeout(function () {
                ElementAction.updateLink({
                    context: oldContext,
                    linkMeta: {
                        id: r.id,
                        vendAt: bendAt
                    }
                })
            }, 10);
        };

        this.listenTo(links, 'add', bend);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/content/diagram.js